module.exports = __webpack_public_path__ + "img/select-img-2.7504c378.png";